var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"img",attrs:{"src":_vm.templateArgs.data.imagem || _vm.imgDefault},on:{"error":_vm.placeholder}})])}
var staticRenderFns = []

export { render, staticRenderFns }